<template>
  <div >
    <div>
      <el-radio v-model="radio" label="0" @change="changeRadio($event)">凸阵</el-radio>
      <el-radio v-model="radio" label="1" @change="changeRadio($event)">线阵</el-radio>
      <el-radio v-model="radio" label="2" @change="changeRadio($event)">相控阵</el-radio>
      <el-radio v-model="radio" label="3" @change="changeRadio($event)">高频线阵</el-radio>
      <el-radio v-model="radio" label="4" @change="changeRadio($event)">容积探头</el-radio>
  </div>
    <div style="margin:20px 0px 20px 0px"> </div>
    <el-upload action="" multiple :limit="10000" :http-request="ossFileupload" :disabled="imagenum.length==0">
      <el-button  type="primary">点击上传</el-button>
    </el-upload>
    <div>
      <el-radio v-model="video" label="1" @change="changeVideoType($event)">超声APP-功能介绍</el-radio>
      <el-radio v-model="video" label="2" @change="changeVideoType($event)">斑筛APP-功能介绍</el-radio>
      <el-radio v-model="video" label="3" @change="changeVideoType($event)">质控培训课程</el-radio>
      <el-radio v-model="video" label="4" @change="changeVideoType($event)">其他视频展示</el-radio>
      <el-radio v-model="video" label="5" @change="changeVideoType($event)">复塑视频展示</el-radio>
  </div>
  <textarea v-model="description" placeholder="请输入 ... "rows="5" cols="35"></textarea>
    <div style="margin:20px 0px 20px 0px"> </div>
    <el-upload action="" multiple :limit="10000" :http-request="ossVideoUpload" :disabled="videoNum.length==0">
      <el-button  type="primary">点击上传</el-button>
    </el-upload>
    <el-upload action="" multiple :limit="10000" :http-request="ossFusuVideoUpload" :disabled="videoNum.length==0">
      <el-button  type="warning">复塑上传</el-button>
    </el-upload>
  </div>
</template>

<script>
import Global from "../Global";
import axios from "axios";
import OSS from "ali-oss";

export default {
  name: "UploadFiles",
  data() {
    return {
      fileList: [], //文件列表
      file: null, //上传的文件
      tempCheckpoint: null, // 用来缓存当前文件内容
      uploadId: "", //上传ID
      uploadStatus: null, // 进度条上传状态
      percentage: 0, // 进度条百分比
      uploadName: "", //Object所在Bucket的完整路径
      radio:'',
      video:'',
      imagenum:'',
      videoNum:'',
      description:''
    };
  },
  methods: {
    changeRadio(val){
      let that =this
      that.imagenum = val
    },
    changeVideoType(val){
      let that = this
      that.videoNum = val
    },
    ossFileupload(param) {
      //param携带上传的所有参数
      //取得文件
      let that = this
      let file = param.file;
      // 取得文件名
      let fileName = file.name;
      let client = new OSS({
        region: "oss-cn-chengdu", // 服务器集群地区
        accessKeyId: "LTAI5tL63oE8AjzwatSYgZjP", // accessKeyId
        accessKeySecret: "NA1EQIl0qTjsANUryVaM5p7fjbPKHR", // accessKeySecret
        // stsToken 可以不写但是不安全
        // stsToken: 'xxx', // 签名token
        bucket: "cloud-image-data", // 阿里云上存储的 Bucket名称
      });
      const headers = {
        // 指定Object的存储类型。
        "x-oss-storage-class": "Standard",
        // 指定Object的访问权限。
        "x-oss-object-acl": "private",
        // 设置Object的标签，可同时设置多个标签。
        "x-oss-tagging": "Tag1=1&Tag2=2",
        // 指定PutObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。
        "x-oss-forbid-overwrite": "true",
      };
      let path = "/" + fileName;
      var response = client.put(path, file);
      response.then((res) => {
        that.axios({
          method: 'POST',
          url: Global.accountUrl + '/imageData/uploadImageData',
          data: [
            {
            name:fileName,
            url:res.url,
            type:this.imagenum
          }
          ]
        })
        .then((response)=>{

        })
      });
    },
    ossVideoUpload(param) {
      //param携带上传的所有参数
      //取得文件
      let that = this
      let file = param.file;
      // 取得文件名
      let fileName = file.name;
      let client = new OSS({
        region: "oss-cn-beijing", // 服务器集群地区
        accessKeyId: "LTAI5tL63oE8AjzwatSYgZjP", // accessKeyId
        accessKeySecret: "NA1EQIl0qTjsANUryVaM5p7fjbPKHR", // accessKeySecret
        // stsToken 可以不写但是不安全
        // stsToken: 'xxx', // 签名token
        bucket: "storkvideo", // 阿里云上存储的 Bucket名称
      });
      const headers = {
        // 指定Object的存储类型。
        "x-oss-storage-class": "Standard",
        // 指定Object的访问权限。
        "x-oss-object-acl": "private",
        // 设置Object的标签，可同时设置多个标签。
        "x-oss-tagging": "Tag1=1&Tag2=2",
        // 指定PutObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。·
        "x-oss-forbid-overwrite": "true",
      };
      let path = "/" + fileName;
      var response = client.put(path, file);
      response.then((res) => {
        that.axios({
          method: 'POST',
          url: Global.accountUrl + '/imageData/uploadVideoData',
          data: [
            {
            filename:fileName,
            url:res.url,
            type:this.videoNum,
            description:this.description
          }
          ]
        })
        .then((response)=>{

        })
      });
    },
    ossFusuVideoUpload(param) {
      //param携带上传的所有参数
      //取得文件
      let that = this
      let file = param.file;
      // 取得文件名
      let fileName = file.name;
      let client = new OSS({
        region: "oss-cn-chengdu", // 服务器集群地区
        accessKeyId: "LTAI5tL63oE8AjzwatSYgZjP", // accessKeyId
        accessKeySecret: "NA1EQIl0qTjsANUryVaM5p7fjbPKHR", // accessKeySecret
        // stsToken 可以不写但是不安全
        // stsToken: 'xxx', // 签名token
        bucket: "fusuflie", // 阿里云上存储的 Bucket名称
      });
      const headers = {
        // 指定Object的存储类型。
        "x-oss-storage-class": "Standard",
        // 指定Object的访问权限。
        "x-oss-object-acl": "private",
        // 设置Object的标签，可同时设置多个标签。
        "x-oss-tagging": "Tag1=1&Tag2=2",
        // 指定PutObject操作时是否覆盖同名目标Object。此处设置为true，表示禁止覆盖同名Object。·
        "x-oss-forbid-overwrite": "true",
      };
      let path = "/" + fileName;
      var response = client.put(path, file);
      response.then((res) => {
        that.axios({
          method: 'POST',
          url: Global.accountUrl + '/imageData/uploadVideoData',
          data: [
            {
            filename:fileName,
            url:res.url,
            type:this.videoNum,
            description:this.description
          }
          ]
        })
        .then((response)=>{

        })
      });
    },
  },
};
</script>

<style scoped>
.file {
  width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/uploadfiles/UploadFiles.vue